var map = {
	"./ajanvaraus-darkblue.svg": "./src/images/icons/ajanvaraus-darkblue.svg",
	"./ajanvaraus-grey.svg": "./src/images/icons/ajanvaraus-grey.svg",
	"./ajanvaraus-lightblue.svg": "./src/images/icons/ajanvaraus-lightblue.svg",
	"./ajanvaraus-white.svg": "./src/images/icons/ajanvaraus-white.svg",
	"./dialyysi-darkblue.svg": "./src/images/icons/dialyysi-darkblue.svg",
	"./dialyysi-lightblue.svg": "./src/images/icons/dialyysi-lightblue.svg",
	"./dialyysi-white.svg": "./src/images/icons/dialyysi-white.svg",
	"./etavastaanotto-darkblue.svg": "./src/images/icons/etavastaanotto-darkblue.svg",
	"./etavastaanotto-grey.svg": "./src/images/icons/etavastaanotto-grey.svg",
	"./etavastaanotto-lightblue.svg": "./src/images/icons/etavastaanotto-lightblue.svg",
	"./etavastaanotto-white.svg": "./src/images/icons/etavastaanotto-white.svg",
	"./hoitokeskustelu-darkblue.svg": "./src/images/icons/hoitokeskustelu-darkblue.svg",
	"./hoitokeskustelu-grey.svg": "./src/images/icons/hoitokeskustelu-grey.svg",
	"./hoitokeskustelu-lightblue.svg": "./src/images/icons/hoitokeskustelu-lightblue.svg",
	"./hoitokeskustelu-white.svg": "./src/images/icons/hoitokeskustelu-white.svg",
	"./kuulolaitehuolto-darkblue.svg": "./src/images/icons/kuulolaitehuolto-darkblue.svg",
	"./kuulolaitehuolto-lightblue.svg": "./src/images/icons/kuulolaitehuolto-lightblue.svg",
	"./kuulolaitehuolto-white.svg": "./src/images/icons/kuulolaitehuolto-white.svg",
	"./kuvantaminen-darkblue.svg": "./src/images/icons/kuvantaminen-darkblue.svg",
	"./kuvantaminen-lightblue.svg": "./src/images/icons/kuvantaminen-lightblue.svg",
	"./kuvantaminen-white.svg": "./src/images/icons/kuvantaminen-white.svg",
	"./kyselyt-darkblue.svg": "./src/images/icons/kyselyt-darkblue.svg",
	"./kyselyt-lightblue.svg": "./src/images/icons/kyselyt-lightblue.svg",
	"./kyselyt-taytetyt-darkblue.svg": "./src/images/icons/kyselyt-taytetyt-darkblue.svg",
	"./kyselyt-taytetyt-lightblue.svg": "./src/images/icons/kyselyt-taytetyt-lightblue.svg",
	"./kyselyt-taytetyt-white.svg": "./src/images/icons/kyselyt-taytetyt-white.svg",
	"./kyselyt-white.svg": "./src/images/icons/kyselyt-white.svg",
	"./labra-darkblue.svg": "./src/images/icons/labra-darkblue.svg",
	"./labra-lightblue.svg": "./src/images/icons/labra-lightblue.svg",
	"./labra-white.svg": "./src/images/icons/labra-white.svg",
	"./minun-hoitoni-darkblue.svg": "./src/images/icons/minun-hoitoni-darkblue.svg",
	"./minun-hoitoni-lightblue.svg": "./src/images/icons/minun-hoitoni-lightblue.svg",
	"./minun-hoitoni-white.svg": "./src/images/icons/minun-hoitoni-white.svg",
	"./palaute-darkblue.svg": "./src/images/icons/palaute-darkblue.svg",
	"./palaute-darkgray.svg": "./src/images/icons/palaute-darkgray.svg",
	"./palaute-lightblue.svg": "./src/images/icons/palaute-lightblue.svg",
	"./palaute-white.svg": "./src/images/icons/palaute-white.svg",
	"./palvelut-darkblue.svg": "./src/images/icons/palvelut-darkblue.svg",
	"./palvelut-lightblue.svg": "./src/images/icons/palvelut-lightblue.svg",
	"./palvelut-white.svg": "./src/images/icons/palvelut-white.svg",
	"./potilasohjeet-darkblue.svg": "./src/images/icons/potilasohjeet-darkblue.svg",
	"./potilasohjeet-lightblue.svg": "./src/images/icons/potilasohjeet-lightblue.svg",
	"./potilasohjeet-white.svg": "./src/images/icons/potilasohjeet-white.svg",
	"./profiili-darkblue.svg": "./src/images/icons/profiili-darkblue.svg",
	"./profiili-lightblue.svg": "./src/images/icons/profiili-lightblue.svg",
	"./profiili-white.svg": "./src/images/icons/profiili-white.svg",
	"./puhelin-darkblue.svg": "./src/images/icons/puhelin-darkblue.svg",
	"./puhelin-lightblue.svg": "./src/images/icons/puhelin-lightblue.svg",
	"./puhelin-white.svg": "./src/images/icons/puhelin-white.svg",
	"./puolesta-asiointi-darkblue.svg": "./src/images/icons/puolesta-asiointi-darkblue.svg",
	"./puolesta-asiointi-lightblue.svg": "./src/images/icons/puolesta-asiointi-lightblue.svg",
	"./puolesta-asiointi-white.svg": "./src/images/icons/puolesta-asiointi-white.svg",
	"./sopimus-black.svg": "./src/images/icons/sopimus-black.svg",
	"./sopimus-darkblue.svg": "./src/images/icons/sopimus-darkblue.svg",
	"./sopimus-lightblue.svg": "./src/images/icons/sopimus-lightblue.svg",
	"./sopimus-white.svg": "./src/images/icons/sopimus-white.svg",
	"./src/ajanvaraus.svg": "./src/images/icons/src/ajanvaraus.svg",
	"./src/dialyysi.svg": "./src/images/icons/src/dialyysi.svg",
	"./src/etavastaanotto.svg": "./src/images/icons/src/etavastaanotto.svg",
	"./src/hoitojakso_osastolla.svg": "./src/images/icons/src/hoitojakso_osastolla.svg",
	"./src/hoitokeskustelu.svg": "./src/images/icons/src/hoitokeskustelu.svg",
	"./src/kuulolaitehuolto.svg": "./src/images/icons/src/kuulolaitehuolto.svg",
	"./src/kuvantaminen.svg": "./src/images/icons/src/kuvantaminen.svg",
	"./src/kyselyt-taytetyt.svg": "./src/images/icons/src/kyselyt-taytetyt.svg",
	"./src/kyselyt.svg": "./src/images/icons/src/kyselyt.svg",
	"./src/labra.svg": "./src/images/icons/src/labra.svg",
	"./src/lahete.svg": "./src/images/icons/src/lahete.svg",
	"./src/minun-hoitoni.svg": "./src/images/icons/src/minun-hoitoni.svg",
	"./src/palaute.svg": "./src/images/icons/src/palaute.svg",
	"./src/palvelut.svg": "./src/images/icons/src/palvelut.svg",
	"./src/potilasohjeet.svg": "./src/images/icons/src/potilasohjeet.svg",
	"./src/profiili.svg": "./src/images/icons/src/profiili.svg",
	"./src/puhelin.svg": "./src/images/icons/src/puhelin.svg",
	"./src/puolesta-asiointi.svg": "./src/images/icons/src/puolesta-asiointi.svg",
	"./src/unipoli-tarvikejakelu.svg": "./src/images/icons/src/unipoli-tarvikejakelu.svg",
	"./src/vastaanotto.svg": "./src/images/icons/src/vastaanotto.svg",
	"./vastaanotto-darkblue.svg": "./src/images/icons/vastaanotto-darkblue.svg",
	"./vastaanotto-lightblue.svg": "./src/images/icons/vastaanotto-lightblue.svg",
	"./vastaanotto-white.svg": "./src/images/icons/vastaanotto-white.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/icons sync recursive ^\\.\\/.*\\.svg$";